import styled from 'styled-components';
import CaCoIn from 'dc/CaCoIn';

export const Input = styled(CaCoIn)`
  color: #263238;
  width: 288px;
  ::placeholder {
    color: #90a4ae;
  }
`;
